'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Choices = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Choices, _Component);

  function Choices(props) {
    (0, _classCallCheck3.default)(this, Choices);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Choices.__proto__ || (0, _getPrototypeOf2.default)(Choices)).call(this, props));

    _this.state = {
      renderedThings: [],
      itemsRendered: 0
    };
    return _this;
  }

  (0, _createClass3.default)(Choices, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate();
    }
  }, {
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate() {
      this.timer = setTimeout(this.updateRenderedThings.bind(this), 1000);
    }
  }, {
    key: 'updateRenderedThings',
    value: function updateRenderedThings() {
      if (this.props.choices.length > 0) {
        var itemsRendered = this.state.itemsRendered;
        var updatedState = {
          renderedThings: this.state.renderedThings.concat(this.props.choices[this.state.itemsRendered]),
          itemsRendered: itemsRendered + 1
        };
        this.setState(updatedState);
        if (updatedState.itemsRendered < this.props.choices.length) {
          this.scheduleNextUpdate();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          choices = _props.choices,
          action = _props.action;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          { transitionName: '__CHAT_TEMPLATE_MESSAGES_TRANSITION_ELEMENT', transitionEnterTimeout: 55000, transitionLeave: false },
          this.state.renderedThings.map(function (choice, i) {
            return _react2.default.createElement(
              'div',
              { key: "choice" + i, className: 'choice', onClick: action.bind(_this2, choice) },
              choice.link ? _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" + _this2.context.project + "/" + _this2.props.currentLanguage + choice.link, draggable: 'false' },
                choice.message
              ) : _react2.default.createElement(
                'span',
                null,
                choice.message
              )
            );
          })
        )
      );
    }
  }]);
  return Choices;
}(_react.Component), _class.propTypes = {
  choices: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    message: _react.PropTypes.string,
    showNextMessages: _react.PropTypes.bool
  })).isRequired,
  action: _react.PropTypes.func,
  currentLanguage: _react.PropTypes.string
}, _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired,
  router: _react2.default.PropTypes.object.isRequired
}, _temp);
exports.default = Choices;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/Choices.js
// module id = 344
// module chunks = 0